import { render } from "./PayPoint.vue?vue&type=template&id=520f56d4&scoped=true"
import script from "./PayPoint.vue?vue&type=script&lang=js"
export * from "./PayPoint.vue?vue&type=script&lang=js"

import "./PayPoint.vue?vue&type=style&index=0&id=520f56d4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520f56d4"]])

export default __exports__